/// <reference types="vite/client" />
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { installErrorReporter } from './net/errorReporter';
import { installCanvasGuards } from './canvasGuards';
import './index.css';

// Install canvas-API guards FIRST — they monkey-patch
// CanvasRenderingContext2D so all subsequent draw calls become safe.
// Eliminates an entire class of "non-finite" / "not a function" errors
// the client reporter has been surfacing.
installCanvasGuards();

// Install client-side error tracking BEFORE rendering — anything that
// throws during App bootstrap (lazy import failures, missing env, etc.)
// then gets caught + POSTed to the server. Without this the operator
// has zero visibility into real-world JS failures.
if (import.meta.env.PROD) {
  installErrorReporter();
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);

// Register the service worker for offline cache + PWA install. Only in
// production — in dev, Vite's HMR conflicts with cached responses.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silent — first-load failure shouldn't block the app.
    });
  });
}
